<p>3. Map the file columns to the recipient list columns:</p>

<table class="mapping-column-table">
  <tr class="mapping-column-table-heading">
    <th style="padding-left:16px;">Recipient list column</th>
    <th>File column</th>
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account ID</td>
    <td class="mapping-column-table-second-td">
      <owc-select-dropdown [formControl]="frmctrlcustomerID" [placeholder]="'Select a file column'"
        (keydown)="onkeyDownEvent($event)" (valueChange)="onDropdownChange($event)">
        @for (option of options; track $index) {
        <owc-list-item [value]="option">
          {{ option }}
        </owc-list-item>
        }
      </owc-select-dropdown>

    </td>
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account name</td>
    <td class="mapping-column-table-second-td">
      <owc-select-dropdown [formControl]="frmctrlcustomerName" [placeholder]="'Select a file column'"
        (keydown)="onkeyDownEvent($event)" (valueChange)="onDropdownChange($event)">
        @for (option of options; track $index) {
        <owc-list-item [value]="option">
          {{ option }}
        </owc-list-item>
        }
      </owc-select-dropdown>

    </td>
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account contact name</td>
    <td class="mapping-column-table-second-td">
      <owc-select-dropdown [value]="frmctrlcustomerContactName" [formControl]="frmctrlcustomerContactName"
        [placeholder]="'Select a file column'" (keydown)="onkeyDownEvent($event)" (valueChange)="onDropdownChange($event)">
        @for (option of options; track $index) {
        <owc-list-item [value]="option">
          {{ option }}
        </owc-list-item>
        }
      </owc-select-dropdown>

    </td>
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account contact email</td>
    <td class="mapping-column-table-second-td">
      <owc-select-dropdown [formControl]="frmctrlcustomerContactEmail" [placeholder]="'Select a file column'"
        (keydown)="onkeyDownEvent($event)" (valueChange)="onDropdownChange($event)">
        @for (option of options; track $index) {
        <owc-list-item [value]="option">
          {{ option }}
        </owc-list-item>
        }
      </owc-select-dropdown>

    </td>
  </tr>
</table>